<script setup lang="ts">
// The "not provided" chip (contract 22 §10) — v3's `Workspace/PleaseEnterCard.vue`, whose 14
// importers are all module 30's. Two literals die with the port: the inline `#fffbec`/`#b37210`
// pair becomes the `--ui-color-not-provided*` tokens, and the hardcoded `'Not Provided'` a key.
// The chip keeps v3's own recipe (soft amber card, regular circle-exclamation, bold caption) —
// 02's warning `Badge` is a mustard status pill and read as an alert next to the value chips.
//
// It takes NO props on purpose. The value it carries is not markup — it is the decision that an
// unset setting reads as a warning-toned chip with exactly this wording, made once for ~20
// definition rows in 30 rather than re-litigated in each.
import { useI18n } from '@/shared/i18n'
import { Icon } from '@/shared/ui'

const { t } = useI18n()
</script>

<template>
  <span
    class="not-provided-badge inline-flex w-max items-center gap-2xs rounded-md bg-not-provided-soft p-2 text-sm text-not-provided shadow-[var(--ui-shadow-sm)]"
    data-testid="not-provided-badge"
  >
    <Icon name="circle-alert" weight="regular" :size="12" aria-hidden="true" />
    <b class="text-xs font-semibold">{{ t('workspaceSettings.common.notProvided') }}</b>
  </span>
</template>
